import { useTranslation } from 'react-i18next';
import { RouteComponentProps } from 'react-router-dom';
import { Helmet } from 'react-helmet';

import { ModerateSubmissionForm } from 'app/pages/ModerateSubmission/ModerateSubmissionForm';
import { getPageStatus, PageLayout } from 'components/PageLayout';
import { useReport } from 'features/reports/hooks/useReport';
import { useAuthState } from 'state/useAuthState';

export const ModerateSubmission = (
  props: RouteComponentProps<{ reportId: string }>,
): JSX.Element => {
  const {
    match: {
      params: { reportId },
    },
  } = props;
  const {
    permissions: { canModerate },
  } = useAuthState();
  const { t } = useTranslation();
  const reportQuery = useReport(Number(reportId));

  const {
    report,
    isReportInError,
    isReportLoading,
    onDeleteReport,
    onUpdateReport,
  } = reportQuery;

  const isAlreadyProcessed =
    report && report.status !== 'llm_reviewed' && report.status !== 'approved';

  const status = getPageStatus({
    isUnauthorized: !canModerate,
    isLoading: isReportLoading,
    isError: isReportInError || !report || isAlreadyProcessed,
  });

  const errorMessage = isAlreadyProcessed
    ? t('moderateSubmission.alreadyProcessed')
    : t('moderateSubmission.loadingError');

  return (
    <PageLayout
      data-cname="ModerateSubmissionLayout"
      status={status}
      headerBarProps={{ title: t('moderateSubmission.header'), action: 'back' }}
      errorMessage={status === 'error' ? errorMessage : undefined}
    >
      {report && !isAlreadyProcessed && (
        <>
          <Helmet>
            <title>{t('moderateSubmission.header')}</title>
          </Helmet>
          <ModerateSubmissionForm
            report={report}
            onDeleteReport={onDeleteReport}
            onUpdateReport={onUpdateReport}
          />
        </>
      )}
    </PageLayout>
  );
};
